import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getLatestHappeningsData} from '../../utils/endpoints'
import Loading from '../components/loading';

const LatestHappenings = (props) => {
    const [latestHappenings, setLatestHappenings] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const latestHappenings = await getLatestHappeningsData(id);
            setLatestHappenings(latestHappenings);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      
    </div>
  );
};

export default LatestHappenings;